interface RouteName {
    key: string;
    path: string;
}

const RouteNames: Record<string, RouteName> = {
    broadcasts: {
        key: 'broadcasts',
        path: '/c/:clientId/broadcasts',
    },
    broadcastsTabs: {
        key: 'broadcastsTabs',
        path: ':activeTab',
    },
    broadcastModal: {
        key: 'broadcastModal',
        path: 'e/:broadcastName/:contentDate/:rightsholderId/:sponsorId/:placementId/:pdf?',
    },
    verbalMentionModal: {
        key: 'verbalMentionModal',
        path: 'vm/:broadcastName/:contentDate/:networkId/:rightsholderId/:sponsorId/:mentionId/:pdf?',
    },
    login: {
        key: 'login',
        path: '/login',
    },
    resetPassword: {
        key: 'reset-password',
        path: '/users/reset-password',
    },
    settings: {
        key: 'settings',
        path: '/c/:clientId/account-settings/*',
    },
    collections: {
        key: 'collections',
        path: '/c/:clientId/collections/(nested)?',
    },
};

export default RouteNames;
